<template lang="pug">
  #TeamLeaderboard
    WtLeaderboard(
      :title="`Team Leaderboard`"
      sub-title="Seven Day Rolling Average"
      :data="teamLeaderboardData"
      :loaded-status="teamLeaderboardLoaded"
    )
    WtPagination(
      :paginationObject="paginationObject"
      @currentPage="currentPage = $event"
      order="is-centered"
    )
</template>

<script>
import { mapActions } from "vuex";
import WtLeaderboard from "@@/WtLeaderboard/WtLeaderboard";
import WtTitle from "@@/WtTitle/WtTitle";
import WtPagination from "@@/WtPagination/WtPagination";

export default {
  name: "TeamLeaderboard",

  components: {
    WtLeaderboard,
    WtTitle,
    WtPagination
  },

  props: {
    team: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      teamLeaderboardData: {},
      teamLeaderboardLoaded: false,
      currentPage: 1
    };
  },

  computed: {
    paginationObject() {
      return this._.get(this.teamLeaderboardData, "pagination", null);
    }
  },

  watch: {
    async currentPage() {
      this.teamLeaderboardLoaded = true;
      this.teamLeaderboardData = await this.fetchTeamLeaderboard({
        teamId: this.team.id,
        page: this.currentPage
      });
      this.teamLeaderboardLoaded = true;
    }
  },

  async mounted() {
    this.teamLeaderboardData = await this.fetchTeamLeaderboard({
      teamId: this.team.id
    });
    this.teamLeaderboardLoaded = true;
  },

  methods: {
    ...mapActions("teams", ["fetchTeamLeaderboard"])
  }
};
</script>

<style lang="sass"></style>
